export { resolve } from 'rsvp';
import Model from '@ember-data/model';
import DS from 'ember-data';

import { isFn } from 'rise-ui/utils/function.js';

export function isEmberDataModelArray(obj) {
  if (obj && (
    obj.isManyArray
    || obj instanceof DS.PromiseArray
  )) {
    console.log('**** isEmberDataModelArray ***',
      obj.isManyArray,
      obj instanceof DS.PromiseArray,
    );
  }
  return (obj && (
    obj.isManyArray
    || obj instanceof DS.PromiseArray
    || obj instanceof DS.PromiseManyArray
  ));
}

export function isEmberDataModel(obj) {
  if (obj instanceof Model) {
    console.log('**** isEmberDataModel ***');
  }
  return obj instanceof Model;
}

export function isEmberData(obj) {
  return isEmberDataModel(obj) || isEmberDataModelArray(obj);
}

export function isAsync(value) {
  return value && value.isPending !== undefined && !isEmberData(value);
}

export function isPromise(value) {
  return isFn(value?.then) && isFn(value?.catch) && isFn(value?.finally);
}

export function promise(value, callIt) {
  return isPromise(value) ? value
    : !callIt ? Promise.resolve(value)
    : new Promise((resolve, reject) => {
      try {
        resolve(value());
      } catch (e) {
        reject(e);
      }
    });
}

/**
 * Returns resolved promise of given truthy value, or returns falsey value
 */
export function syncResolved(value) {
  return value && Promise.resolve(value);
}
